import { Box, Typography } from "@mui/material";
import MyToastShow from "@/components/Layout/MyToast";
import ActionButton from "@/components/Tablas/TableBase/ActionButton";
import { memo, useState } from "react";
import { informeApi, useImprimirInformeMutation } from "@/redux/api/informeApi";
import { IInforme } from "@/redux/models";
import { useTablaCarritoV2Props, ViewAs } from "../../logics/useTablaCarritoV2";
import { modalInformeType } from "../Modals";
import { LoadingSpinner } from "./TableRowInformes";

const InformeAction = ({ setModal, informe, modificarInforme, viewAs }: { viewAs: useTablaCarritoV2Props['viewAs'], setModal: useTablaCarritoV2Props['setModal'], modal: useTablaCarritoV2Props['modal'], informe: IInforme, modificarInforme: useTablaCarritoV2Props['modificarInforme'] }) => {

  const { VER_INFORME, EDITAR_INFORME, GESTIONAR_INFORMADO, ELIMINAR_INFORME, RECHAZAR_INFORME } = modalInformeType;
  const [imprimirInforme] = useImprimirInformeMutation();

  const [obtenerInformePorId] = informeApi.endpoints.obtenerInformePorId.useLazyQuery();
  const [isLoading, setIsLoading] = useState<Boolean>(false);

  const handleSelectInforme = async (action: modalInformeType) => {
    setIsLoading(true)
    obtenerInformePorId(informe.id).unwrap().then((informe) => {
      setModal(action, informe)
    }).catch((err) => {
      MyToastShow({ message: "Error al obtener el informe", type: "error" })
    }).finally(() => { setIsLoading(false) });
  }

  const handleMarcarImpreso = () => {
    const nuevoEstado = !informe.printed;
    imprimirInforme({ id: informe.id, printed: nuevoEstado }).unwrap().then((res) => {
      modificarInforme({ ...informe, printed: nuevoEstado })
      MyToastShow({ message: `${informe.printed ? 'Desm' : 'M'}arcado como impreso`, type: "success" })

    }).catch((err) => {
      MyToastShow({ message: "Error al marcar como impreso", type: "error" })
    })
  }


  //menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //menu 

  return (<>
    {isLoading && (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // fondo semi-transparente
          zIndex: 9999, // asegurarse de que esté por encima de todo lo demás
        }}
      >
        <LoadingSpinner />
        <Typography
          sx={{
            marginTop: 2,
            color: 'white',
            fontSize: '1.5rem',
            fontWeight: 'bold', // hace el texto más grueso
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)', // agrega sombra para mayor legibilidad
            textAlign: 'center', // centra el texto
          }}
        >
          Cargando informe...
        </Typography>
      </Box>
    )}

    <Box sx={{ display: 'flex', width: 'min-content' }}>

      <Box>
        <ActionButton
          title="Ver"
          onClick={() => handleSelectInforme(VER_INFORME)}
          icon="remove_red_eye"
        />
        <ActionButton
          title="Informar"
          onClick={() => setModal(GESTIONAR_INFORMADO, informe)}
          icon="file_present"
          hide={viewAs === ViewAs.USER}
        />


      </Box>
      <Box>
        <ActionButton
          title="Editar"
          onClick={() => handleSelectInforme(EDITAR_INFORME)}
          icon="edit"
          hide={viewAs === ViewAs.USER}
        />
        <ActionButton
          title={`${informe.printed ? 'Desm' : 'M'}arcar como impreso `}
          onClick={() => handleMarcarImpreso()}
          icon="print"
          hide={viewAs === ViewAs.USER}
        />
      </Box>

      <Box sx={{ alignContent: 'center' }}>

        <ActionButton
          title="Rechazar"
          onClick={() => setModal(RECHAZAR_INFORME, informe)}
          icon="report_problem"
          sx={{ color: '#ff980e' }}
          hide={viewAs === ViewAs.USER}
        />

        <ActionButton
          title="Borrar"
          onClick={() => setModal(ELIMINAR_INFORME, informe)}
          icon="highlight_off"
          sx={{ color: '#d32f2f' }}
          hide={viewAs === ViewAs.USER}
        />

      </Box>




    </Box>
  </>);
}

export default memo(InformeAction, (prev, next) => {
  return prev.modal.type === next.modal.type && prev.setModal === next.setModal && false
})